import React from 'react';
import { ProgressBar, ProgressFill, UploadStats } from './styles';

const DocumentProgress = ({ sent, total }) => {
  if (total === 0) return null;
  
  const percent = (sent / total) * 100;
  
  return (
    <>
      <UploadStats>
        <span>Progresso do envio</span>
        <span>{sent} de {total} obrigatório(s)</span>
      </UploadStats>
      <ProgressBar>
        <ProgressFill $percent={percent} />
      </ProgressBar>
    </>
  );
};

export default DocumentProgress;